import OutageNotification from "../entities/outageNotification";

const outageNotificationDataTransformationAfterFetch = (data) => {
  return data.map((row) => {
    return new OutageNotification(row);
  });
};

export default outageNotificationDataTransformationAfterFetch;
